import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'dcc-status-indicator',
  template: `
    <div class="status-indicator lx-body">
      <span class="status {{ statusCss }}"></span>
      {{ value }}
    </div>
  `,
  styleUrls: ['./status-indicator.component.scss'],
})
export class StatusIndicatorComponent implements OnInit, OnChanges {
  @Input() value: string;
  @Input() color: StatusColor = StatusColor.blue;

  statusCss: string;

  ngOnChanges(): void {
    this.statusCss = this.color;
  }

  ngOnInit(): void {
    this.statusCss = this.color;
  }
}

export enum StatusColor {
  red = 'status-red',
  blue = 'status-blue',
  green = 'status-green',
  yellow = 'status-yellow',
  none = 'status-none',
}
